export function AiGradientSvg() {
    return (
      <svg width="0" height="0">
        <linearGradient
          id="ai_gradient"
          x1="5.5"
          y1="0"
          x2="5.5"
          y2="18.7731"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D55DFF" />
          <stop offset="1" stopColor="#54A7FF" />
        </linearGradient>
      </svg>
    );
  }
  